import * as interfaces from "../../interfaces";
import { DslElement } from "../common";

export abstract class Expression extends DslElement implements interfaces.IExpression {
  isExpression: true = true as const;
  abstract toJson(): interfaces.IExpression;
  abstract toDsl(indent: number): string;
}
